<div
  class="box-border w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="flex flex-row items-center">
    @if (showLabelLeft()) {
      <span class="pr-2" [attr.data-testid]="id() | appendTestId: 'label'">
        {{ formattedLabel() }}
      </span>
    }
    <label
      [attr.data-testid]="id() | appendTestId: 'toggle'"
      (pointerdown)="startPress($event)"
      (pointercancel)="endPress()"
      (pointerleave)="endPress()"
      (click)="toggle($event)"
      [attr.aria-label]="label()"
      [for]="id()"
      (keydown.space)="toggle($event)"
      class="border-input-ring bg-input-background relative inline-block h-8 w-13 cursor-pointer rounded-full border-2 transition-colors duration-200 ease-out [-webkit-tap-highlight-color:transparent] motion-reduce:transition-none"
      [ngClass]="{
        'cursor-not-allowed!': ngControl.control!.disabled,
        'has-checked:bg-primary-main':
          !ngControl.control!.disabled,
      }">
      <input
        [attr.data-testid]="id() | appendTestId: 'toggle-input'"
        [id]="id()"
        [checked]="isActive()"
        [disabled]="ngControl.control!.disabled"
        type="checkbox"
        class="peer focus:ring-input-focus disabled:bg-standard-disabled disabled:checked:bg-standard-disabled pointer-events-none h-full w-full appearance-none rounded-full border-0 bg-transparent checked:bg-transparent checked:bg-none focus:ring-2" />

      <span
        [ngClass]="{
          'scale-150': isPressed(),
          'hover:scale-150': !ngControl.control!.disabled,
          'peer-checked:scale-125': !isPressed(),
        }"
        class="bg-standard-text-secondary peer-checked:peer-enabled:bg-primary-on absolute top-1/2 left-1.5 size-4 -translate-y-1/2 rounded-full transition-all duration-200 ease-out peer-checked:translate-x-5 motion-reduce:transition-none"></span>
    </label>
    @if (!showLabelLeft()) {
      <span class="pl-2" [attr.data-testid]="id() | appendTestId: 'label'">
        {{ formattedLabel() }}
      </span>
    }
  </div>
  @if (hasError && !errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-content></ng-content>
    </aw-error-message>
  }
  @if (hasError && errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
